"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var formats = {
  US: '{address.line1}\n{address.line2}\n{address.city}, {address.stateProvince} {address.postalCode}\n{address.country}',
  BY: '{address.line1}\n{address.line2}\n{address.postalCode}, {address.stateProvince}\n{address.country}',
  BE: '{address.line1}\n{address.line2}\n{address.postalCode} {address.city}\n{address.country}',
  NL: '{address.line1}\n{address.line2}\n{address.postalCode} {address.city}\n{address.country}',
  PA: '{address.line1}\n{address.line2}\n{address.postalCode}\n{address.stateProvince}\n{address.country}',
  PL: '{address.line1}\n{address.line2}\n{address.postalCode} {address.city}\n{address.country}'
};
var _default = exports["default"] = formats;